import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Card, CardContent } from "../../components/ui/card";
import { toast } from "sonner";

const EVENTS = [
  "lead_assigned","site_visit_reminder_24h","site_visit_reminder_2h",
  "proposal_sent","proposal_viewed","proposal_accepted",
  "contract_sent","contract_signed","deposit_requested","deposit_marked_paid",
];
const CHANNELS = ["email","sms","in_app"];

export default function NotificationTemplates() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({ subject: "", body: "", channel: "email", enabled: true });

  const load = async () => {
    try { const r = await api.get("/notification-templates"); setItems(r.data); if (!selected && r.data[0]) select(r.data[0]); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const select = (t) => { setSelected(t); setForm({ subject: t.subject || "", body: t.body || "", channel: t.channel, enabled: t.enabled }); };

  const save = async () => {
    if (!selected) return;
    try {
      await api.patch(`/notification-templates/${selected.event}`, form);
      toast.success("Template updated");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <AppShell title="Notification Templates" subtitle={`${items.length} event template(s) · merge-field editable · owner-only`}>
      <div className="grid gap-6 lg:grid-cols-[280px_1fr]">
        <aside className="bg-white border border-erf-borderCream rounded-md p-2 max-h-[80vh] overflow-y-auto" data-testid="nt-list">
          {items.map((t) => (
            <button
              key={t.event}
              onClick={() => select(t)}
              className={`w-full text-left px-3 py-2 rounded ${selected?.event === t.event ? "bg-erf-gold/15" : "hover:bg-erf-creamSecondary"}`}
              data-testid={`nt-item-${t.event}`}
            >
              <div className="font-mono text-[11px] text-erf-dark/80">{t.event}</div>
              <div className="text-[10px] font-nav text-erf-dark/50 mt-0.5 uppercase tracking-widest">{t.channel} · {t.enabled ? "on" : "off"}</div>
            </button>
          ))}
        </aside>
        {selected && (
          <Card className="border-erf-borderCream" data-testid="nt-editor">
            <CardContent className="p-5 space-y-3">
              <div className="text-[11px] font-mono uppercase tracking-widest text-erf-gold">{selected.event}</div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label className="text-xs uppercase font-nav">Channel</Label>
                  <Select value={form.channel} onValueChange={(v)=>setForm({...form, channel: v})}>
                    <SelectTrigger className="mt-1" data-testid="nt-channel"><SelectValue /></SelectTrigger>
                    <SelectContent>{CHANNELS.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-xs uppercase font-nav">Enabled</Label>
                  <Select value={form.enabled ? "on" : "off"} onValueChange={(v)=>setForm({...form, enabled: v === "on"})}>
                    <SelectTrigger className="mt-1" data-testid="nt-enabled"><SelectValue /></SelectTrigger>
                    <SelectContent><SelectItem value="on">on</SelectItem><SelectItem value="off">off</SelectItem></SelectContent>
                  </Select>
                </div>
              </div>
              <div>
                <Label className="text-xs uppercase font-nav">Subject (email/in_app)</Label>
                <Input value={form.subject} onChange={(e)=>setForm({...form, subject: e.target.value})} className="mt-1" data-testid="nt-subject" />
              </div>
              <div>
                <Label className="text-xs uppercase font-nav">Body (merge fields wrapped in {"{{"}...{"}}"} )</Label>
                <Textarea value={form.body} onChange={(e)=>setForm({...form, body: e.target.value})} className="mt-1 font-mono text-xs" rows={12} data-testid="nt-body" />
              </div>
              <Button onClick={save} className="bg-erf-gold text-erf-dark hover:bg-erf-goldHover" data-testid="nt-save">Save template</Button>
              <div className="text-[10px] font-mono text-erf-dark/40 uppercase tracking-widest pt-2 border-t border-erf-borderCream">
                Templates apply to messages sent through the providers shown as Connected and Verified on Integrations & API.
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </AppShell>
  );
}
